module.exports = __webpack_public_path__ + "img/slider_a01_l.45fa4e2.25a1b0d4.png";